import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CommonTable } from 'gnos-tables'
import _ from 'lodash'

import './style.scss'

export default class DataTable extends Component {
    static propTypes = {
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            dataTable: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            firm: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sector: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            firmEvolution: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sectorEvolution: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sectorAverage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            firmVersusSector: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            pointer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const { id, data, translates } = this.props

        return (
            <div className={'rg-table-wrapper'}>
                <CommonTable
                    id={`${id}-data-table`}
                    itemIdentifier={'type'}
                    columnsDefinition={[
                        {
                            accessor: 'text',
                            Header: _.get(translates, 'pointer'),
                            headerClassnames: ['align-left-th'],
                        },
                        {
                            accessor: 'firm',
                            Header: _.get(translates, 'firm'),
                            headerClassnames: ['firm-th', 'align-right-th'],
                            Cell: (value) => (
                                <div style={{ textAlign: 'right' }}>
                                    {_.isNil(_.get(value, 'value'))
                                        ? '-'
                                        : _.toNumber(_.get(value, 'value', 0)).toFixed(2)}
                                </div>
                            ),
                            width: 80,
                        },
                        {
                            accessor: 'sector',
                            Header: _.get(translates, 'sector'),
                            headerClassnames: ['sector-th', 'align-right-th'],
                            Cell: (value) => (
                                <div style={{ textAlign: 'right' }}>
                                    {_.isNil(_.get(value, 'value'))
                                        ? '-'
                                        : _.toNumber(_.get(value, 'value', 0)).toFixed(2)}
                                </div>
                            ),
                            width: 80,
                        },
                        {
                            accessor: 'firmVersusSector',
                            Header: _.get(translates, 'firmVersusSector'),
                            headerClassnames: ['firmVersusSector-th', 'align-right-th'],
                            Cell: (value) => (
                                <div style={{ textAlign: 'right' }}>
                                    {_.isNil(_.get(value, 'value'))
                                        ? '-'
                                        : `${_.toNumber(_.get(value, 'value', 0)).toFixed(2)} %`}
                                </div>
                            ),
                            width: 180,
                        },
                    ]}
                    staticData={{
                        _table: data,
                    }}
                />
            </div>
        )
    }
}
